import { removeParamsFromQuery } from '@marketplace-web/shared/utils'

export const removeFeedbackUrlParam = (relativeUrl: string, urlQuery: string) =>
  removeParamsFromQuery(relativeUrl, urlQuery, ['offline_verification_feedback_seller'])
